import { Link } from "react-router-dom";
import { Instagram, MapPin } from "lucide-react";
import { LOGO_URL } from "@/api";
import { LotusMark } from "@/components/Reveal";

const Footer = () => (
  <footer data-testid="site-footer" className="bg-maroon-ink text-ivory-card mt-0">
    <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 py-16 sm:py-20">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
        <div>
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="Vaiyra emblem" className="w-12 h-12 rounded-full ring-1 ring-gold/50 object-cover" />
            <div>
              <p className="font-brand text-2xl tracking-[0.18em]">VAIYRA</p>
              <p className="text-[9px] tracking-[0.42em] text-gold-light mt-1">ROOTED IN GRACE</p>
            </div>
          </div>
          <p className="mt-6 text-sm text-ivory-card/70 leading-relaxed max-w-xs">
            For you with Grace. Thank you for making VAIYRA a part of your wardrobe.
          </p>
        </div>
        <div>
          <p className="text-[10px] tracking-[0.4em] uppercase text-gold mb-6">The Maison</p>
          <ul className="space-y-3 text-sm text-ivory-card/80">
            <li><Link to="/" data-testid="footer-link-home" className="hover:text-gold-light transition-colors">Maison Vaiyra</Link></li>
            <li><Link to="/shop" data-testid="footer-link-shop" className="hover:text-gold-light transition-colors">The Collection</Link></li>
            <li><Link to="/shop?category=short-kurta" data-testid="footer-link-short-kurtas" className="hover:text-gold-light transition-colors">Short Kurtas</Link></li>
            <li><Link to="/shop?category=long-kurta" data-testid="footer-link-long-kurtas" className="hover:text-gold-light transition-colors">Long Kurtas</Link></li>
            <li><Link to="/shop?category=cord-set" data-testid="footer-link-cord-sets" className="hover:text-gold-light transition-colors">Cord Sets</Link></li>
            <li><Link to="/track" data-testid="footer-link-track" className="hover:text-gold-light transition-colors">Track Your Order</Link></li>
          </ul>
          <p className="mt-6 text-[10px] tracking-[0.28em] uppercase text-gold-light/80">Shipping</p>
          <p className="mt-2 text-xs text-ivory-card/60 leading-relaxed max-w-xs">
            Dispatched in 2–3 working days · Delivered across India in 5–7 days.
          </p>
        </div>
        <div>
          <p className="text-[10px] tracking-[0.4em] uppercase text-gold mb-6">Let's Connect</p>
          <a
            href="https://instagram.com/vaiyra.in"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram-link"
            className="inline-flex items-center gap-3 border border-gold/40 hover:border-gold px-5 py-3 transition-colors"
          >
            <Instagram className="w-4 h-4 text-gold-light" />
            <span className="text-sm tracking-[0.15em]">@vaiyra.in</span>
          </a>
          <p className="mt-6 flex items-center gap-2 text-sm text-ivory-card/60">
            <MapPin className="w-4 h-4 text-gold-light" /> Woven & stitched in India
          </p>
          <a href="mailto:hello@vaiyra.in" className="mt-3 inline-block text-xs text-ivory-card/70 hover:text-gold-light transition-colors">
            hello@vaiyra.in
          </a>
        </div>
      </div>
      <div className="mt-16 pt-8 border-t border-gold/20 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-ivory-card/50">© 2026 VAIYRA. All threads reserved.</p>
        <LotusMark className="w-5 h-5 text-gold/70" />
      </div>
    </div>
  </footer>
);

export default Footer;
